module.exports = __webpack_public_path__ + "img/newchris-96.79e9cc89.jpg";